import { useEffect } from 'react';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { fetchNotifications, markNotificationRead, markAllRead } from './api';
import { connectSocket } from '../../services/socket';

export const NOTIFICATIONS_KEY = ['notifications'] as const;

export function useNotifications(params?: { unreadOnly?: boolean }) {
  return useQuery({
    queryKey: [...NOTIFICATIONS_KEY, params],
    queryFn: () => fetchNotifications(params),
    refetchInterval: 60_000,
  });
}

export function useRealtimeNotifications() {
  const qc = useQueryClient();
  useEffect(() => {
    let remove: (() => void) | null = null;
    connectSocket()
      .then((sock) => {
        const handler = () => qc.invalidateQueries({ queryKey: NOTIFICATIONS_KEY });
        sock.on('new-notification', handler);
        remove = () => sock.off('new-notification', handler);
      })
      .catch(() => {});
    return () => {
      remove?.();
    };
  }, [qc]);
}

export function useMarkRead() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => markNotificationRead(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: NOTIFICATIONS_KEY }),
  });
}

export function useMarkAllRead() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: markAllRead,
    onSuccess: () => qc.invalidateQueries({ queryKey: NOTIFICATIONS_KEY }),
  });
}
